/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Terms_Of_Service_Label_TextInputs */

const en_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Terms of Service`)
};

const ar_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`شروط الخدمة`)
};

const de_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bedingungen der Dienstleistung`)
};

const es_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Términos del servicio`)
};

const fr_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conditions d'utilisation`)
};

const it_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termini di Servizio`)
};

const ja_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用規約`)
};

const ko_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`이용약관`)
};

const pt_br_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Termos de Serviço`)
};

const ru_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Условия использования`)
};

const th_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เงื่อนไขการให้บริการ`)
};

const tr_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hizmet Şartları`)
};

const zh_cn_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服务条款`)
};

const zh_tw_terms_of_service_label_text = /** @type {(inputs: Terms_Of_Service_Label_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`服務條款`)
};

/**
* | output |
* | --- |
* | "Terms of Service" |
*
* @param {Terms_Of_Service_Label_TextInputs} inputs
* @param {{ locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }} options
* @returns {LocalizedString}
*/
export const terms_of_service_label_text = /** @type {((inputs?: Terms_Of_Service_Label_TextInputs, options?: { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Terms_Of_Service_Label_TextInputs, { locale?: "en" | "ar" | "de" | "es" | "fr" | "it" | "ja" | "ko" | "pt_br" | "ru" | "th" | "tr" | "zh_cn" | "zh_tw" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_terms_of_service_label_text(inputs)
	if (locale === "ar") return ar_terms_of_service_label_text(inputs)
	if (locale === "de") return de_terms_of_service_label_text(inputs)
	if (locale === "es") return es_terms_of_service_label_text(inputs)
	if (locale === "fr") return fr_terms_of_service_label_text(inputs)
	if (locale === "it") return it_terms_of_service_label_text(inputs)
	if (locale === "ja") return ja_terms_of_service_label_text(inputs)
	if (locale === "ko") return ko_terms_of_service_label_text(inputs)
	if (locale === "pt_br") return pt_br_terms_of_service_label_text(inputs)
	if (locale === "ru") return ru_terms_of_service_label_text(inputs)
	if (locale === "th") return th_terms_of_service_label_text(inputs)
	if (locale === "tr") return tr_terms_of_service_label_text(inputs)
	if (locale === "zh_cn") return zh_cn_terms_of_service_label_text(inputs)
	return zh_tw_terms_of_service_label_text(inputs)
});